module.exports = __webpack_public_path__ + "static/media/logo_vegas-pro.53ba7423.png";